import {
  useEvent,
  useEventsOnViewLoad
} from '@emerald-works/react-event-bus-client'
import { useDispatch, useSelector } from 'react-redux'
import { b2cSignupSlice } from '../../../reducers'
import { useGoogleAnalyticsEvent } from '../../../hooks'
import { useNavigate } from 'react-router-dom'
import { VERIFICATION_STEP } from './progress-bar'
import { ERRORS_ALREADY_SUBSCRIBED, ERRORS_PAYMENT_FAILED } from './const'

const usePaymentEvent = ({ onSuccess, onError, onComplete } = {}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { sendPurchaseEvent } = useGoogleAnalyticsEvent()
  const plan = useSelector(b2cSignupSlice.selectors.selectPlan)

  const [event] = useEvent([
    {
      eventName: 'subscriptionInitiatePayment',
      onError: (error) => {
        console.error('Failed to process payment', error)
        if (error?.code === 'PAYMENT_SUBSCRIPTION_EXISTS') {
          dispatch(b2cSignupSlice.actions.setPaymentError(ERRORS_ALREADY_SUBSCRIBED))
        }
        if (error?.code === 'PAYMENT_ERROR') {
          dispatch(b2cSignupSlice.actions.setPaymentError(ERRORS_PAYMENT_FAILED))
        }
        onError && onError(error)
        onComplete && onComplete()
      }
    }
  ])

  useEventsOnViewLoad(() => {
    const listener = event.registerAdhocOnSuccessListener(({ payload }) => {
      const username = payload.accountCode.replace('code-', '')
      dispatch(b2cSignupSlice.actions.setCurrentStep(VERIFICATION_STEP))
      sendPurchaseEvent(payload, plan)
      onSuccess && onSuccess(payload)
      onComplete && onComplete()
      navigate(`/b2c/sign-up/success/${username}/${plan?.code}`)
    })

    return () => {
      event.unregisterAdhocListener(listener, 'onSuccess')
    }
  }, [plan])

  return event
}

export default usePaymentEvent
